import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ImCross } from "react-icons/im";
import LoadingSpinner from '../../Components/Components/LoadingSpinner';
import SelectBox from 'devextreme-react/select-box';
import { Form } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Providers/AuthProvider';
import { toast } from 'react-toastify';
import { checkIfPasswordMeetsConditions, passwordConditionText } from '../../Helpers/CheckPassword';
import { FaRegEye } from 'react-icons/fa6';
import { Licenses } from '../../Data/Licenses.ts';
import useCheckLicense from '../../Hooks/useCheckLicense.ts';
import { useCompanyInfo } from '../../Providers/CompanyInfoProvider';

const ChangePassword = () => {
    const { handleCheckChangePasswordLink, handleChangePasswordFromLink } = useAuth()
    const activationCalled = useRef(false)
    const params = new URLSearchParams(window.location.search)
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [newPassword, setNewPassword] = useState('')
    const [reEntryNewPassword, setReEntryNewPassword] = useState('')
    const [errorText, setErrorText] = useState('')
    const [selectedCompany, setSelectedCompany] = useState(null)
    const [checkLinkResult, setCheckLinkResult] = useState(null)
    const [companies, setCompanies] = useState([])
    const [loading, setLoading] = useState(false)
    const [isPasswordIncorrect, setIsPasswordIncorrect] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [showReEntryPassword, setShowReEntryPassword] = useState(false)
    const [isNew, setIsNew] = useState(false)
    const { checkLicense } = useCheckLicense()
    const [isValidLicense, setIsValidLicense] = useState(checkLicense([Licenses.TgInstalacje]))
    const [isTerms_and_conditions_of_the_trading_portal, setIsTerms_and_conditions_of_the_trading_portal] = useState(false)
    const [isTerms_and_conditions_OWS, setIsTerms_and_conditions_OWS] = useState(false)
    const { companyInfoData } = useCompanyInfo()

    const [handlingMarketingAgree, setHandlingMarketingAgree] = useState({
        marketingAgree: false, marketingAgreeEmail: false, marketingAgreePhone: false, marketingAgreeSms: false, terms_and_conditions_of_the_trading_portal: false, terms_and_conditions_OWS: false
    });

    const [marketingAgree2, setMarketingAgree2] = useState(false);

    const handlemarketingAgree2Change = (checked) => {
        if (!checked) {
            setHandlingMarketingAgree({ ...handlingMarketingAgree, marketingAgreeEmail: false, marketingAgreePhone: false, marketingAgreeSms: false });
        } else {
            setHandlingMarketingAgree({ ...handlingMarketingAgree, marketingAgreeEmail: true, marketingAgreePhone: true, marketingAgreeSms: true })
        }
    };

    useEffect(() => {
        if (params.get("isNew")) {
            const value = params.get("isNew");
            setIsNew(parseBool(value));
        }
        if (params.get("KOD") && !activationCalled.current) {
            activationCalled.current = true
            const data = {
                url: encodeURIComponent(window.location.search)
            }
            checkLink(data.url)
        }

    }, [])

    const parseBool = (value) => {
        if (value === "1" || value === "true") return true;
        if (value === "0" || value === "false") return false;
        return false;
    };

    const checkLink = async (link) => {
        const result = await handleCheckChangePasswordLink(link)
        if (result) {
            setCompanies(result)
            setSelectedCompany(result[0])
            setCheckLinkResult(true)
        }
        else {
            setCompanies(null)
            setCheckLinkResult(false)
        }
    }
    const handleTextChange = (e, type) => {
        setErrorText('')
        if (type === 'newPassword') {
            setNewPassword(e.target.value)
        }
        else {
            setReEntryNewPassword(e.target.value)
        }
    }
    const handleChangePassword = async () => {
        if (!newPassword || !reEntryNewPassword || newPassword.trim() === '' || reEntryNewPassword.trim() === '') {
            setErrorText('Proszę zupełnić pola!')
            return
        }
        if (newPassword !== reEntryNewPassword) {
            setErrorText('Hasła muszą być take same!')
            return
        }
        if (!selectedCompany) {
            setErrorText('Proszę wybrać konto!')
            return
        }
        else if (isNew && !handlingMarketingAgree.marketingAgree) {
            setErrorText("Prosze zaznaczyć wymagane zgody!")
            return
        }
        if (isNew && isValidLicense) {
            if (!handlingMarketingAgree.terms_and_conditions_of_the_trading_portal || !handlingMarketingAgree.terms_and_conditions_OWS) {
                setErrorText("Prosze zaznaczyć wymagane zgody!")
                return
            }
        }

        const missingRequirements = Object.values(checkIfPasswordMeetsConditions(newPassword))
            .filter((data) => data && !data.valid)
            .map((data) => data.description)
            .join(", ");
        if (missingRequirements) {
            setIsPasswordIncorrect(true)
            setErrorText('Hasło nie spełnia wymagań!')
            return
        }

        setLoading(true)
        let link = encodeURIComponent(window.location.search)
        const res = await handleChangePasswordFromLink(link, selectedCompany.custId, newPassword, handlingMarketingAgree.marketingAgree, handlingMarketingAgree.marketingAgreeEmail, handlingMarketingAgree.marketingAgreePhone, handlingMarketingAgree.marketingAgreeSms)
        setLoading(false)
        if (res.result) {
            toast.success('Pomyślnie zmieniono hasło. Możesz się teraz zalogować.')
            // toast.success('Pomyślnie zmieniono hasło. Możesz się teraz zalogować.', {
            //     toastId: 'password-changed'
            // })
            navigate('/login')
        }
        else {
            setErrorText(res.errorMessage)
            return
        }
    }
    const handleChangeCompany = (e) => {
        setSelectedCompany(e.value)
    }

    let passwordConditionTextStyle = isPasswordIncorrect ? 'error-text-color' : ''

    const handleDownloadPolicy = (policy) => {
        let consentLink = ''
        switch (policy) {
            case "terms_and_conditions_of_the_trading_portal":
                setIsTerms_and_conditions_of_the_trading_portal(true)
                consentLink = '/Statements/TG/Regulamin Portalu Transakcyjnego E-Handel.pdf'
                window.open(consentLink, '_blank')

                break;
            case "terms_and_conditions_OWS":
                setIsTerms_and_conditions_OWS(true)
                consentLink = '/Statements/TG/OWS.pdf'
                window.open(consentLink, '_blank')

                break;
        }
    }

    const handleChange = (e) => {
        const { id, checked } = e.target;
        // if (id === "terms_and_conditions_of_the_trading_portal" && !isTerms_and_conditions_of_the_trading_portal) {
        //   setError('Pobierz Regulamin Portalu Transakcyjnego E-Handel, aby zaznaczyć pole!')
        // }
        // else if (id === "terms_and_conditions_OWS" && !isTerms_and_conditions_OWS) {
        //   setError('Pobierz politykę OWS (Ogólnych Warunków Sprzedaży), aby zaznaczyć pole!')
        // }
        // else {
        //   setHandlingRegister({
        //     ...handlingRegister,
        //     [id]: checked
        //   });

        //   if (id === "marketingAgree2") {
        //     handlemarketingAgree2Change(checked);
        //   }

        //   if (handlingRegister.marketingAgreeEmail === true || handlingRegister.marketingAgreePhone === true || handlingRegister.marketingAgreeSms === true) {
        //     setMarketingAgree2(true);
        //   }

        //   if (handlingRegister.marketingAgreeEmail === false && handlingRegister.marketingAgreePhone === false && handlingRegister.marketingAgreeSms === false) {
        //     setMarketingAgree2(false);
        //   }
        //   setError('')
        // }

        if (id === "terms_and_conditions_of_the_trading_portal" && !isTerms_and_conditions_of_the_trading_portal) {
            handleDownloadPolicy('terms_and_conditions_of_the_trading_portal')
        }
        else if (id === "terms_and_conditions_OWS" && !isTerms_and_conditions_OWS) {
            handleDownloadPolicy('terms_and_conditions_OWS')
        }

        setHandlingMarketingAgree({
            ...handlingMarketingAgree,
            [id]: checked
        });

        if (id === "marketingAgree2") {
            handlemarketingAgree2Change(checked);
        }

        if (handlingMarketingAgree.marketingAgreeEmail === true || handlingMarketingAgree.marketingAgreePhone === true || handlingMarketingAgree.marketingAgreeSms === true) {
            setMarketingAgree2(true);
        }

        if (handlingMarketingAgree.marketingAgreeEmail === false && handlingMarketingAgree.marketingAgreePhone === false && handlingMarketingAgree.marketingAgreeSms === false) {
            setMarketingAgree2(false);
        }
        setErrorText('')
    }

    // if (loading || checkLinkResult === null) {
    //     return <LoadingSpinner />
    // }
    // if (!checkLinkResult) {
    //     return (
    //         <div className="container main-container-holder">
    //             <div className="row mt-4 mb-4">
    //                 <ImCross size={150} className='error-text-color' />
    //             </div>
    //             <div className="row text-center">
    //                 <b style={{ fontSize: '30px' }}>Link jest niepoprawny lub wygasł czas ważności linku!</b>
    //             </div>
    //         </div>
    //     )
    // }
    return (
        <Form autoComplete="off" onSubmit={e => { e.preventDefault(); }}>
            <div className="container main-container-holder mt-5 mb-5">
                <div className="row text-center">
                    <div className='panel-header-title'>Wybierz konto, dla którego chcesz zmienić hasło.</div>
                </div>
                <div className="row mt-3 d-flex justify-content-center">
                    <div className="col-6">
                        <SelectBox
                            items={companies}
                            value={selectedCompany}
                            inputAttr={{ autoComplete: 'off', name: 'companySelect' }}
                            placeholder='Wybierz konto'
                            noDataText='Brak danych'
                            displayExpr={(item) => item ? `'${item.name}' NIP: ${item.nip}` : ''}
                            onValueChanged={handleChangeCompany}
                        />
                    </div>
                </div>
                <div className="row mt-3 d-flex justify-content-center">
                    <div className="col-6 d-flex align-items-center">
                        <Form.Control
                            id='password'
                            type={showPassword ? 'text' : 'password'}
                            placeholder={t("new-password")}
                            value={newPassword}
                            onChange={(e) => handleTextChange(e, 'newPassword')}
                        />
                        <FaRegEye
                            color='var(--primary)'
                            size={20} className='element-pointer ms-2 me-2'
                            onMouseDown={() => setShowPassword(true)}
                            onMouseUp={() => setShowPassword(false)}
                            onMouseLeave={() => setShowPassword(false)}
                            onTouchStart={() => setShowPassword(true)}
                            onTouchEnd={() => setShowPassword(false)}
                        />
                    </div>
                </div>
                <div className="row mt-3 d-flex justify-content-center">
                    <div className="col-6 d-flex align-items-center">
                        <Form.Control
                            id='password'
                            type={showReEntryPassword ? 'text' : 'password'}
                            placeholder={t("re-entry-new-password")}
                            value={reEntryNewPassword} onChange={(e) => handleTextChange(e, 're-entry-new-password')}
                        />
                        <FaRegEye
                            color='var(--primary)'
                            size={20} className='element-pointer ms-2 me-2'
                            onMouseDown={() => setShowReEntryPassword(true)}
                            onMouseUp={() => setShowReEntryPassword(false)}
                            onMouseLeave={() => setShowReEntryPassword(false)}
                            onTouchStart={() => setShowReEntryPassword(true)}
                            onTouchEnd={() => setShowReEntryPassword(false)}
                        />
                    </div>
                </div>
                <div className="row d-flex mt-3 justify-content-center">
                    <div className="col text-center">
                        <span className={passwordConditionTextStyle}>{passwordConditionText}</span>
                    </div>
                </div>
                {(isNew) ? <>
                    <div className='row justify-content-center mt-3'>
                        {(isValidLicense) ? <> <div className="consent-checkbox">
                            <input type="checkbox" id="terms_and_conditions_of_the_trading_portal" className="checkbox-custom"
                                checked={handlingMarketingAgree.terms_and_conditions_of_the_trading_portal}
                                onChange={handleChange} />
                            <label>
                                {t("terms_and_conditions_of_the_trading_portal")}
                                <span className='error-text-color'> *</span>
                            </label>
                            <div className="row d-flex ms-2">
                                <label className='app-link m-0 me-3 p-0' onClick={() => handleDownloadPolicy('terms_and_conditions_of_the_trading_portal')}>
                                    {t("download")}
                                </label>
                            </div>
                        </div>
                            <div className="consent-checkbox">
                                <input type="checkbox" id="terms_and_conditions_OWS" className="checkbox-custom"
                                    checked={handlingMarketingAgree.terms_and_conditions_OWS}
                                    onChange={handleChange} />
                                <label>
                                    {t("terms_and_conditions_OWS")}
                                    <span className='error-text-color'> *</span>
                                </label>
                                <div className="row d-flex ms-2">
                                    <label className='app-link m-0 me-3 p-0' onClick={() => handleDownloadPolicy('terms_and_conditions_OWS')}>
                                        {t("download")}
                                    </label>
                                </div>
                            </div>
                        </> : <></>
                        }
                        <div className="consent-checkbox">
                            <input type="checkbox" id="marketingAgree" className="checkbox-custom"
                                checked={handlingMarketingAgree.marketingAgree}
                                onChange={handleChange} />
                            <label htmlFor="consent-marketing">
                                {t("consent_marketing1")}{companyInfoData.name}{t("consent_marketing2")}
                                <span className='error-text-color'> *</span>
                            </label>
                        </div>
                        <div className="consent-checkbox">
                            <input type="checkbox" id="marketingAgree2" className="checkbox-custom"
                                onChange={handleChange} />
                            <label htmlFor="consent-info">
                                {t("consent_info1")}{companyInfoData.name}{t("consent_info2")}
                            </label>
                        </div>
                        <div className="checkbox-options">
                            <div className="option">
                                <input type="checkbox" className="checkbox-custom" id="marketingAgreeEmail"
                                    checked={handlingMarketingAgree.marketingAgreeEmail}
                                    onChange={handleChange} />
                                <label htmlFor="email">Email</label>
                            </div>
                            <div className="option">
                                <input type="checkbox" className="checkbox-custom" id="marketingAgreePhone"
                                    checked={handlingMarketingAgree.marketingAgreePhone}
                                    onChange={handleChange} />
                                <label htmlFor="phone">{t("phone")}</label>
                            </div>
                            <div className="option">
                                <input type="checkbox" className="checkbox-custom" id="marketingAgreeSms"
                                    checked={handlingMarketingAgree.marketingAgreeSms}
                                    onChange={handleChange} />
                                <label htmlFor="sms">Sms</label>
                            </div>
                        </div>
                    </div >
                </> : <></>}
                <div className="row d-flex justify-content-center mt-3">
                    <div className="col-6 text-center">
                        <b className='error-text-color'>{errorText}</b>
                    </div>
                </div>
                <div className="row mt-5 d-flex justify-content-center">
                    <div className="col-6 d-flex justify-content-between">
                        <button className='btn-app-primary' onClick={() => handleChangePassword()}>Zmień hasło</button>
                        <button className='btn-app-secondary' onClick={() => navigate('/')}>Anuluj</button>
                    </div>
                </div>
            </div>
        </Form>
    )
}

export default ChangePassword